const styleByName = (color) => {
	switch(color) {
		case 'Ingen':
			return {};
		case 'Grå':
			return {background: '#F1F1F1', padding: '1em'};
		case 'Vit':
			return {background: '#FFFFFF', padding: '1em'};
		case 'Grön':
			return {background: '#80BCAB', color: '#FFFFFF'};
		default:
			return null;
	}
}

export default styleByName;



// WEBPACK FOOTER //
// ./src/utils/styleByName.js